(function () {
  'use strict';
  if (customElements.get('mh-campaign-popup')) return;
  const seen = new Set();
  function utc(value) {
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(value)) return NaN;
    const time = Date.parse(value);
    return Number.isFinite(time) && new Date(time).toISOString().replace('.000Z', 'Z') === value ? time : NaN;
  }
  class CampaignPopup extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.display = this.querySelector('[data-mh-popup-display]');
      this.preview = this.dataset.preview === 'true';
      this.offers = Array.from(this.querySelectorAll('template[data-mh-popup-offer]')).map(template => ({template,start:utc(template.dataset.start),end:utc(template.dataset.end),key:'mh-campaign-popup-v1:'+template.dataset.code+':'+template.dataset.start+':'+template.dataset.end})).filter(x => Number.isFinite(x.start) && Number.isFinite(x.end) && x.end > x.start);
      this.dismissed = new Set();
      this.started = Date.now();
      this.delay = Math.max(3,Math.min(15,Number(this.dataset.delay)||6))*1000;
      this.duration = Math.max(5,Math.min(30,Number(this.dataset.duration)||14))*1000;
      this.onClick = event => this.clickAction(event);
      this.onKey = event => { if(event.key === 'Escape' && !this.hidden && !this.blocked()) this.close(); };
      this.onEnter = () => { this.hovered=true;this.pause(); };
      this.onLeave = () => { this.hovered=false;this.resume(); };
      this.onFocus = () => this.pause();
      this.onBlur = () => { clearTimeout(this.blurTimer);this.blurTimer=setTimeout(()=>this.resume(),0); };
      this.onVisibility = () => { if(document.hidden)this.pause();else{this.refresh();this.resume();} };
      this.addEventListener('click',this.onClick);
      this.addEventListener('mouseenter',this.onEnter);
      this.addEventListener('mouseleave',this.onLeave);
      this.addEventListener('focusin',this.onFocus);
      this.addEventListener('focusout',this.onBlur);
      document.addEventListener('keydown',this.onKey);
      document.addEventListener('visibilitychange',this.onVisibility);
      this.refresh();
    }
    wasSeen(offer) {
      if(this.dismissed.has(offer.key))return true;
      if(this.preview)return false;
      if(seen.has(offer.key))return true;
      try{return sessionStorage.getItem(offer.key)==='1';}catch(_){return false;}
    }
    blocked() {
      return document.body.style.overflow==='hidden' || Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"],.drawer.is-open,.drawer--open')).some(el=>{
        if(this.contains(el) || el.closest('[hidden],[aria-hidden="true"]'))return false;
        const style=getComputedStyle(el),rect=el.getBoundingClientRect();
        return style.display!=='none' && style.visibility!=='hidden' && Number(style.opacity)>0 && rect.width>0 && rect.height>0 && rect.right>0 && rect.bottom>0 && rect.left<innerWidth && rect.top<innerHeight;
      });
    }
    refresh() {
      clearTimeout(this.watchTimer);
      if(!this.isConnected || !this.display)return;
      const now=Date.now();
      const offer=this.preview?this.offers[0]:this.offers.find(x=>now>=x.start && now<x.end);
      if(this.current && (this.current!==offer || this.blocked()))this.close();
      if(offer && this.hidden && !this.wasSeen(offer)) {
        const ready=this.preview || now-this.started>=this.delay;
        const typing=/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName||'');
        if(ready && !document.hidden && !typing && !this.blocked())this.show(offer);
      }
      const times=this.offers.flatMap(x=>[x.start,x.end]).filter(t=>t>now);
      let interval = 60000;
      if(!this.hidden)interval=1000;
      else if(offer && !this.wasSeen(offer))interval=Math.max(25,Math.min(1000,this.delay-(now-this.started)+10));
      if(this.offers.length)this.watchTimer=setTimeout(()=>this.refresh(),Math.min(interval,...times.map(t=>Math.max(25,t-now+10))));
    }
    show(offer) {
      this.display.replaceChildren(offer.template.content.cloneNode(true));
      this.current=offer;this.returnFocus=document.activeElement;this.remaining=this.duration;this.hidden=false;
      if(!this.preview){seen.add(offer.key);try{sessionStorage.setItem(offer.key,'1');}catch(_){}}
      this.resume();
    }
    pause() {
      clearTimeout(this.autoTimer);
      if(this.deadline)this.remaining=Math.max(0,this.deadline-Date.now());
      this.deadline=0;
    }
    resume() {
      if(this.hidden || this.preview || this.hovered || document.hidden || this.contains(document.activeElement))return;
      this.pause();
      if(this.remaining<=0){this.close();return;}
      this.deadline=Date.now()+this.remaining;
      this.autoTimer=setTimeout(()=>this.close(),this.remaining);
    }
    close() {
      this.pause();this.hidden=true;
      if(this.current)this.dismissed.add(this.current.key);
      if(this.contains(document.activeElement) && this.returnFocus?.isConnected)this.returnFocus.focus({preventScroll:true});
      this.display?.replaceChildren();this.current=null;
    }
    async clickAction(event) {
      if(event.target.closest('[data-mh-popup-close]')){this.close();return;}
      if(event.target.closest('[data-mh-popup-link]')){this.pause();this.hidden=true;return;}
      const button=event.target.closest('[data-mh-popup-copy]');
      if(!button)return;
      const offer=this.current,status=this.querySelector('[data-mh-popup-status]');
      try{
        if(!navigator.clipboard || !window.isSecureContext)throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(button.dataset.mhPopupCopy);
        if(status && offer===this.current)status.textContent=this.dataset.copied;
      }catch(_){if(status && offer===this.current)status.textContent=this.dataset.copyFallback;}
    }
    disconnectedCallback() {
      clearTimeout(this.watchTimer);clearTimeout(this.blurTimer);this.pause();
      this.removeEventListener('click',this.onClick);this.removeEventListener('mouseenter',this.onEnter);this.removeEventListener('mouseleave',this.onLeave);this.removeEventListener('focusin',this.onFocus);this.removeEventListener('focusout',this.onBlur);
      document.removeEventListener('keydown',this.onKey);document.removeEventListener('visibilitychange',this.onVisibility);
      this.ready=false;
    }
  }
  customElements.define('mh-campaign-popup',CampaignPopup);
})();
